window.Bernie = window.Bernie || {};
window.Bernie['client-stores'] = window.Bernie['client-stores'] || {};
var mod = require("-!/app-build/node_modules/happypack/loader.js?id=ts!/app-build/src/stores/client.ts");
Object.keys(mod).forEach(function (key) { window.Bernie['client-stores'][key] = mod[key]; });
module.exports = window.Bernie['client-stores'];